/** Mirrors COMPANY_WEB_HOST_ID_REGEX in @fias/db-types (a portal's id). */
export const COMPANY_WEB_HOST_ID_PATTERN = /^cwh_[0-9a-f]{32}$/;

/** Mirrors COMPANY_WEB_CALLBACK_PATH in @fias/db-types: the portal server's sign-in callback. */
export const COMPANY_WEB_CALLBACK_PATH = '/v1/auth/company-callback';
